/**
 * Index gate for `/settings/payments` (DNKADM-0132). The fixed OAuth return
 * `/settings/payments?connect=...` must keep landing on the Connection editor with
 * its toast + context restore, so when a `connect` param is present we forward to
 * `connection` PRESERVING the entire query string (`connect`/`reason`). The preserved
 * route then forwards into Overview's drawer. Every ordinary visit lands on Overview.
 *
 * Lives in its own file (not inline in `router.tsx`) so the route-config module keeps
 * its non-component `routes`/`router` exports without tripping react-refresh.
 */
import { Navigate, useSearchParams } from 'react-router-dom';

export function PaymentsSettingsIndexRedirect() {
  const [searchParams] = useSearchParams();
  if (searchParams.has('connect')) {
    return <Navigate to={`connection?${searchParams.toString()}`} replace />;
  }
  return <Navigate to="overview" replace />;
}
